import { useEffect, useState } from 'react'

import { createSandboxSelector, type RuleEngineSandbox } from '../../../../domain'

import { useAppState } from '../../State'

const createRuleEngineHook = <P extends keyof RuleEngineSandbox>(prop: P): () => RuleEngineSandbox[P] => () => useAppState(createSandboxSelector(prop))

export const useSelectedType = createRuleEngineHook('type')

export const useEndpoints = createRuleEngineHook('endpoints')

export const useSelectedEndpoints = createRuleEngineHook('selectedEndpoints')

export const useInput = createRuleEngineHook('input')

export const useSelectedTopics = createRuleEngineHook('selectedTopics')

export const useTransformation = createRuleEngineHook('transformation')

const useOutputState = createRuleEngineHook('output')

/**
 * This caches the output from the state of the application
 * and maximizes the chance of it being loaded
 *
 * Even if it is outdated
 */
export const useOutput: () => RuleEngineSandbox['output'] = () => {
    const output = useOutputState()
    const [loaded, setLoaded] = useState(() => output)

    useEffect(() => {
        if (output.loaded) {
            setLoaded(output)
        }
    }, [output])

    return loaded
}
